export const INIT_ADMINS = [
  { id: 1, name: "Ramesh Sharma", username: "ramesh123", password: "pass123", email: "ramesh@apitservices.com", phone: "9876543210", society: "Vitthal Plaza Co-Op Housing Society", city: "Navi Mumbai", state: "Maharashtra", status: "Active", createdAt: "2025-01-10" },
  { id: 2, name: "Priya Mehta", username: "priya_admin", password: "priya@456", email: "priya@apitservices.com", phone: "9123456780", society: "Sunrise Residency CHS", city: "Thane", state: "Maharashtra", status: "Active", createdAt: "2025-02-14" },
  { id: 3, name: "Ashok Kumar", username: "ashok_adm", password: "ashok789", email: "ashok@apitservices.com", phone: "9988776655", society: "Green Valley Society", city: "Pune", state: "Maharashtra", status: "Inactive", createdAt: "2025-03-01" },
];

export const STATS = [
  { label: "Total Members", value: "1,344", color: "#1a6fc4", bg: "#e8f1fb", icon: "members" },
  { label: "Active Flats", value: "1,320", color: "#0f9d58", bg: "#e6f4ea", icon: "building" },
  { label: "Pending Bills", value: "₹2,84,500", color: "#f57c00", bg: "#fff3e0", icon: "finance" },
  { label: "Open Complaints", value: "12", color: "#d32f2f", bg: "#fce8e6", icon: "bell" },
];

export const MENU = [
  { id: "home", label: "Home", icon: "home" },
  {
    id: "admin", label: "Admin", icon: "admin", children: [
      { id: "register-society", label: "Register New Society" },
      { id: "change-password", label: "Change Password" },
      { id: "manage-society", label: "Manage Society" },
      { id: "data-locking", label: "Data Locking" },
      {
        id: "manage-member", label: "Manage Member", children: [
          { id: "upload-members-data", label: "Upload Members Data" },
          { id: "upload-vehicle-data", label: "Upload Vehicle Data" },
          { id: "edit-member-details", label: "Edit Member Details" },
          { id: "manage-parking", label: "Manage Parking" },
        ]
      },
      { id: "documents-manager", label: "Documents Manager" },
      { id: "notice-manager", label: "Notice Manager" },
      { id: "event-manager", label: "Event Manager" },
      {
        id: "manage-complaints", label: "Manage Complaints", children: [
          { id: "create-tickets", label: "Create Tickets" },
          { id: "view-tickets", label: "View Tickets" },
        ]
      },
      { id: "user-rights", label: "User Rights" },
      { id: "sub-committee", label: "Sub Committee" },
      { id: "staff-management", label: "Staff Management" },
      {
        id: "manager", label: "Manager", children: [
          { id: "manager-registration", label: "Manager Registration" },
          { id: "set-manager", label: "Set Manager" },
          { id: "manager-rights", label: "Manager Rights" },
        ]
      },
    ]
  },
  {
    id: "accounts", label: "Accounts", icon: "finance", children: [
      { id: "set-account", label: "Account Groups" },
      { id: "set-account-subgroup", label: "Account Sub Groups" },
      { id: "bank-cash-master", label: "Bank / Cash Master" },
      { id: "account-master", label: "Account Master" },
      { id: "budget", label: "Budget" },
      { id: "set-charges", label: "Set Charges" },
      { id: "bill-parameters", label: "Bill Parameters" },
      {
        id: "bill-generation-menu", label: "Bill Generation", children: [
          { id: "bill-generation-regular", label: "Regular Bill" },
          { id: "bill-generation-regular-individual", label: "Regular Bill (Individual)" },
          { id: "bill-generation-supplementary", label: "Supplementary Bill" },
          { id: "bill-generation-supplementary-individual", label: "Supplementary Bill (Individual)" },
        ]
      },
      {
        id: "vendors-menu", label: "Vendors", children: [
          { id: "vendors-add", label: "Add Vendors" },
          { id: "vendors-contract", label: "Vendor Contract" },
          { id: "vendors-billing", label: "Vendor Billing" },
          { id: "vendors-report", label: "Vendor Report" },
        ]
      },
      { id: "bank-reconciliation", label: "Bank Reconciliation" },
      { id: "bank-slip", label: "Bank Slip" },
      { id: "import-transactions", label: "Import Transactions" },
      { id: "transfer-closing-balances", label: "Transfer Closing Balances" },
      { id: "fixed-deposits", label: "Fixed Deposits" },
    ]
  },
  {
    id: "transactions", label: "Transactions", icon: "tracker", children: [
      { id: "transaction-menu", label: "Transaction Entry" },
      { id: "receipts", label: "Receipts" },
      { id: "payments", label: "Payments" },
      { id: "general-receipts", label: "General Receipts" },
      { id: "contra", label: "Contra" },
    ]
  },
  {
    id: "bank-cash", label: "Bank & Cash Reports", icon: "bank", children: [
      { id: "bankbook", label: "Bankbook Report" },
      { id: "cashbook", label: "Cash Book Report" },
      { id: "reconciliation", label: "Reconciliation Report" },
      { id: "receipt-payment", label: "Receipt & Payment" },
    ]
  },
  {
    id: "income-expense", label: "Income & Expense Tracker", icon: "tracker", children: [
      { id: "tariff-ledger", label: "Tariff Ledger" },
      { id: "general-ledger", label: "General Ledger" },
      { id: "expense-report", label: "Expense Report" },
      { id: "income-report", label: "Income Report" },
    ]
  },
  {
    id: "members-reports", label: "Members Reports", icon: "members", children: [
      { id: "opening-balances", label: "Opening Balances" },
      { id: "billwise-dues", label: "Billwise Dues Report" },
      { id: "member-ledger-a", label: "Member Ledger Format A" },
      { id: "member-ledger-b", label: "Member Ledger Format B" },
    ]
  },
  {
    id: "gst-reports", label: "GST Reports", icon: "gst", children: [
      { id: "gst-billing", label: "GSTR - Billing" },
      { id: "gst-vendors", label: "GSTR - Vendors" },
    ]
  },
  {
    id: "final-accounts", label: "Final Accounts", icon: "finance", children: [
      { id: "income-expenditure", label: "Income & Expenditure" },
      { id: "trial-balance", label: "Trial Balance" },
      { id: "balancesheet", label: "Balance Sheet" },
      { id: "fund-flow", label: "Fund Flow" },
    ]
  },
  {
    id: "society-reports", label: "Society Reports", icon: "registers", children: [
      { id: "committee-members", label: "Committee Members" },
      { id: "society-members", label: "Society Members" },
      { id: "tenants", label: "List Of Tenants" },
      { id: "parking-report", label: "Parking Report" },
    ]
  },
  {
    id: "registers", label: "Registers", icon: "registers", children: [
      { id: "fd-register", label: "FD Register" },
      { id: "shares-register", label: "Shares Register" },
      { id: "lien-register", label: "Lien Register" },
      { id: "nominee-register", label: "Nominee Register" },
    ]
  },
  { id: "user-manual", label: "User Manual", icon: "manual" },
  { id: "refer-earn", label: "Refer & Earn", icon: "refer" },
];

export const SA_MENU = [
  { id: "sa-dash", label: "Dashboard", icon: "home" },
  { id: "sa-create", label: "Create Admin", icon: "plus" },
  { id: "sa-list", label: "All Admins", icon: "members" },
  { id: "sa-societies", label: "All Societies", icon: "society" },
  { id: "sa-settings", label: "Settings", icon: "lock" },
];
